<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input
                  v-model="queryParam.mobile"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('手机号')"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户昵称')" prop="nickName">
                <a-input
                  v-model="queryParam.nickName"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('用户昵称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('实名认证状态')" prop="certificationStatus">
                <a-select v-model="queryParam.certificationStatus" allowClear>
                  <a-select-option value="1">{{ $t('未认证') }}</a-select-option>
                  <a-select-option value="2">{{ $t('已认证') }}</a-select-option>
                  <a-select-option value="3">{{ $t('审核中') }}</a-select-option>
                  <a-select-option value="4">{{ $t('审核失败') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户角色')" prop="userRole">
                <a-select
                  :placeholder="$t('通用.输入.请选择') + $t('用户角色')"
                  v-model="queryParam.userRole"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option :value="50">{{ $t('会员') }}</a-select-option>
                  <a-select-option :value="60">{{ $t('班长') }}</a-select-option>
                  <a-select-option :value="70">{{ $t('课代表') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('分账接收方状态')" prop="receiverStatus">
                <a-select v-model="queryParam.receiverStatus" allowClear>
                  <a-select-option value="1">{{ $t('已创建') }}</a-select-option>
                  <a-select-option value="0">{{ $t('未创建') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('分账绑定状态')" prop="bindStatusList">
                <a-select v-model="queryParam.bindStatusList" mode="multiple" allowClear :placeholder="$t('请选择分账绑定状态')">
                  <a-select-option value="2">{{ $t('审核中') }}</a-select-option>
                  <a-select-option value="3">{{ $t('审核失败') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('收款账户名称')" prop="acctName">
                <a-input
                  v-model="queryParam.acctName"
                  :maxLength="64"
                  :placeholder="$t('通用.输入.请输入') + $t('收款账户名称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('收款账户卡号')" prop="acctNo">
                <a-input
                  v-model="queryParam.acctNo"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('收款账户卡号')"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  ><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>

        <!-- 分账关系绑定列表 -->
        <a-modal
          :title="$t('查看分账关系绑定列表')"
          :visible="bindListVisible"
          :footer="null"
          :width="800"
          @cancel="bindListCancel"
        >
          <a-table
            :loading="bindListLoading"
            rowKey="id"
            :columns="bindListColumns"
            :data-source="bindList"
            :pagination="false"
            size="middle"
            bordered
          >
            <span slot="bindStatusText" slot-scope="text, record">
              <a-badge
                :status="record.bindStatus === '1' ? 'success' : record.bindStatus === '2' ? 'processing' : record.bindStatus === '3' ? 'error' : 'default'"
                :text="record.bindStatusText"
              />
            </span>
            <span slot="operation" slot-scope="text, record">
              <a v-if="record.bindStatus === '2' || record.bindStatus === '3'" @click="reSubmitBind(record)" :disabled="record.submitting">
                <a-icon type="reload" />{{ $t('重新提交审核') }}
              </a>
            </span>
            <span slot="empty">
              {{ $t('暂无绑定记录') }}
            </span>
          </a-table>
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleApplyLedgerReceiver" v-hasPermi="['biz:user:applyLedgerReceiver']">
          <a-icon type="plus" />{{ $t('批量上传拉卡拉分账接收方') }}
        </a-button>
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:user:add']">-->
        <!--          <a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:user:edit']">-->
        <!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:user:remove']">-->
        <!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:user:export']">-->
        <!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
        <!--        </a-button>-->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :rowSelection="rowSelection"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" />
          <a v-if="record.certificationStatus == 3" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('通用.按钮.审核') }}
          </a>
          <a v-else @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('通用.按钮.详情') }}
          </a>
          <a-divider type="vertical" />
          <a v-if="record.receiverNo" @click="openBindList(record)">
            <a-icon type="link" />{{ $t('查看分账关系绑定列表') }}
          </a>
          <a-divider type="vertical" />
<!--          <a v-if="record.certificationStatus == 2" @click="settingLevelHandle(record)"> {{ $t('设置主播等级') }}</a>-->
          <!--          <a-divider type="vertical" v-hasPermi="['user:user:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['user:user:remove']">-->
          <!--            <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
          <!--          </a>-->
        </span>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img
              v-if="record.avatar"
              :src="record.avatar"
              style="width: 60px; height: 62px"
              @click="handleRecordPreview(record.avatar)"
              alt="none"
            />
          </div>
        </template>
        <template slot="receiverApplyMsg" slot-scope="text, record">
          <a-tooltip v-if="record.receiverApplyMsg" placement="topLeft">
            <template slot="title">
              <span>{{ record.receiverApplyMsg }}</span>
              <div v-if="record.receiverApplyTime" style="margin-top: 4px">
                {{ $t('创建时间') }}：{{ parseTime(record.receiverApplyTime) }}
              </div>
            </template>
            <span :style="{ color: record.receiverNo ? '#52c41a' : '#ff4d4f' }">
              {{ record.receiverApplyMsg }}
            </span>
          </a-tooltip>
          <span v-else>-</span>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <setting-level ref="settingLevelModal" @success="getList"></setting-level>
  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser, applyLedgerReceiver, receiverBindList, reSubmitReceiverBind } from '@/api/biz/user'
// import { pageUser,listUser, delUser } from '@/api/user/user'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import SettingLevel from './modules/SettingLevel.vue'

export default {
  name: 'User',
  components: {
    CustomDictTag,
    CreateForm,
    SettingLevel,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 分账关系绑定列表弹窗
      bindListVisible: false,
      bindListLoading: false,
      bindList: [],
      bindListQuery: {},
      bindListColumns: [
        { title: this.$t('绑定店铺'), dataIndex: 'shopName', align: 'center' },
        { title: this.$t('接收方编号'), dataIndex: 'receiverNo', align: 'center' },
        { title: this.$t('绑定状态'), dataIndex: 'bindStatusText', align: 'center', scopedSlots: { customRender: 'bindStatusText' } },
        { title: this.$t('备注'), dataIndex: 'remark', align: 'center' },
        { title: this.$t('创建时间'), dataIndex: 'createTime', align: 'center', customRender: (t) => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '-') },
        { title: this.$t('更新时间'), dataIndex: 'updateTime', align: 'center', customRender: (t) => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '-') },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', align: 'center', scopedSlots: { customRender: 'operation' } },
      ],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      submitLoading: false,
      // 多选配置
      rowSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.ids = selectedRows.map((item) => item.id)
          this.single = selectedRowKeys.length !== 1
          this.multiple = !selectedRowKeys.length
        },
      },
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: undefined,
        avatar: undefined,
        nickName: undefined,
        realName: undefined,
        userRole: undefined,
        certificationStatus: undefined,
        receiverStatus: undefined,
        bindStatusList: undefined,
        acctName: undefined,
        acctNo: undefined,
        idCard: undefined,
        idCardFace: undefined,
        idCardCountry: undefined,
        certificationOpinion: undefined,
        userRole: undefined,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('用户.头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center',
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: this.$t('用户信息.真实姓名'),
        //   dataIndex: 'realName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('实名认证状态'),
          dataIndex: 'certificationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return '未认证'
            }
            if (v == 2) {
              return '已认证'
            }
            if (v == 3) {
              return '审核中'
            } else {
              return '审核驳回'
            }
          },
        },
        {
          title: this.$t('开户行名称'),
          dataIndex: 'acctOpenBankName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('收款账户名称'),
          dataIndex: 'acctName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('收款账户卡号'),
          dataIndex: 'acctNo',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('开户行号'),
          dataIndex: 'acctOpenBankCode',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('清算行号'),
          dataIndex: 'acctClearBankCode',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('分账接收方状态'),
          dataIndex: 'receiverNo',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v && v !== '') {
              return '已创建'
            }
            return '未创建'
          },
        },
        {
          title: this.$t('分账接收方返回信息'),
          dataIndex: 'receiverApplyMsg',
          width: 220,
          align: 'center',
          scopedSlots: { customRender: 'receiverApplyMsg' },
        },
        // {
        //   title: this.$t('用户信息.身份证号'),
        //   dataIndex: 'idCard',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户信息.实名认证审核意见'),
        //   dataIndex: 'certificationOpinion',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        avatar: undefined,
        nickName: undefined,
        realName: undefined,
        userRole: undefined,
        certificationStatus: undefined,
        receiverStatus: undefined,
        bindStatusList: undefined,
        acctName: undefined,
        acctNo: undefined,
        idCard: undefined,
        idCardFace: undefined,
        idCardCountry: undefined,
        certificationOpinion: undefined,
        userRole: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.rowSelection.selectedRowKeys = []
      this.ids = []
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.rowSelection.selectedRowKeys = selectedRowKeys
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 批量创建拉卡拉分账接收方 */
    handleApplyLedgerReceiver() {
      if (this.ids.length === 0) {
        this.$message.warning(this.$t('通用.文本.请先选择数据'))
        return
      }
      const that = this
      this.$confirm({
        title: this.$t('批量创建分账接收方'),
        content: this.$t('确认对已选择的') + this.ids.length + this.$t('条用户创建拉卡拉分账接收方？'),
        onOk() {
          that.submitLoading = true
          return applyLedgerReceiver({ ids: that.ids })
            .then((res) => {
              const data = res.data || {}
              that.$message.success(
                that.$t('创建完成') +
                  '：' +
                  that.$t('成功') +
                  data.success +
                  '，' +
                  that.$t('跳过') +
                  data.skip +
                  '，' +
                  that.$t('失败') +
                  data.fail
              )
              if (data.errors && data.errors.length > 0) {
                console.warn('分账接收方创建失败明细：', data.errors)
              }
              that.rowSelection.selectedRowKeys = []
              that.ids = []
              that.getList()
            })
            .finally(() => {
              that.submitLoading = false
            })
        },
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    /** 查看分账关系绑定列表 */
    openBindList(record) {
      this.bindListVisible = true
      this.bindListLoading = true
      this.bindList = []
      this.bindListQuery = { userId: record.id, receiverNo: record.receiverNo }
      receiverBindList(this.bindListQuery)
        .then((res) => {
          this.bindList = res.data || []
        })
        .finally(() => {
          this.bindListLoading = false
        })
    },
    bindListCancel() {
      this.bindListVisible = false
    },
    /** 重新提交分账关系绑定审核 */
    reSubmitBind(record) {
      const that = this
      this.$confirm({
        title: this.$t('重新提交审核'),
        content: this.$t('确认重新提交该分账关系绑定申请？'),
        okText: this.$t('通用.按钮.确定'),
        cancelText: this.$t('通用.按钮.取消'),
        onOk() {
          record.submitting = true
          reSubmitReceiverBind({ bindId: record.id })
            .then(() => {
              that.$message.success(that.$t('提交成功，等待审核'))
              // 重新拉取列表
              return receiverBindList(that.bindListQuery)
            })
            .then((res) => {
              that.bindList = res.data || []
            })
            .finally(() => {
              record.submitting = false
            })
        },
      })
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delUser(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = that.$t('通用.文本.删除成功')
            that.$message.success(message, 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('user/user/export', ...that.queryParam, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
    settingLevelHandle(record) {
      this.$refs.settingLevelModal.showModal(record)
    },
  },
}
</script>
